module.exports = __webpack_public_path__ + "static/img/shuiya3.8b35d09e.png";